import React from "react"
import { MenuOutlined } from "@ant-design/icons"
import { useLocation } from "react-router-dom"

const PAGE_TITLES = {
  "qr-view": "View QR Code",
  "user-payment": "User Payment",
  "user-profile": "My Profile",
  "user-bookslot": "Book Slot",
}

export default function UserTopbar({ onMenuClick }) {
  const location = useLocation()
  const currentPage = location.pathname.split("/").pop()

  return (
    <header className="topbar">
      <button
        className="topbar-icon-btn topbar-menu-btn"
        onClick={onMenuClick}
        style={{ border: "none" }}
      >
        <MenuOutlined style={{ fontSize: 18 }} />
      </button>

      <h1 className="topbar-title">
        {PAGE_TITLES[currentPage] || "Dashboard"}
      </h1>

      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <div className="topbar-user-chip">
          <div className="chip-avatar">U</div>
          <span className="d-none d-sm-inline">User</span>
        </div>
      </div>
    </header>
  )
}